import { Outlet, useParams } from "react-router-dom";

import GlobalConfig from "app/config/global";
import PageWrapper from "app/components/PageWrapper";

import { useProjectsApi } from "features/admin/projects/useProjects";

const ProjectsLayout = () => {
    const { projectId } = useParams();
    const { useProjectById } = useProjectsApi();

    const projectData = useProjectById(projectId);

    return (
        <PageWrapper
            title={projectData?.data?.Name ?? "Error"}
            menuOptions={[
                {
                    children: "Admin",
                    to: GlobalConfig.routes.adminLandingPage,
                },
                {
                    children: "Projects",
                    to: GlobalConfig.routes.adminProjectsLanding,
                },
            ]}
            loading={projectData?.isLoading}
            customAuthPath={GlobalConfig.routes.adminProjectsLanding}
        >
            <Outlet />
        </PageWrapper>
    );
};

export default ProjectsLayout;
